// functions for getting dataURLs to pass into pptxgen

import domtoimage from 'dom-to-image';
// NOTE: domtoimage is only known to work in Chrome and Firefox. It depends on the
// <foreignObject> svg feature which is absent from IE11, and doesn't work with
// Safari or Edge's implementation of the feature

// create a png representation of the user's flowchart
export const getCanvasImage = () => new Promise ((resolve, reject) => {

  // these are the viewport dimensions from chart-older.svg scale these
  // dimensions if a higher-resolution png is needed
  const chartWidth = '1102px';
  const chartHeight = '1045px';

  const snapChart = document.querySelector('.SnapChart');
  const clone = snapChart.cloneNode(true);

  document.body.appendChild(clone);

  // set clone and chart positions to static, or users will be able to see
  // cloned element!
  clone.style.position = 'static';
  clone.style.width = chartWidth;
  clone.style.height = chartHeight;

  const chart = clone.querySelector("#chart");

  chart.style.position = 'static';
  chart.style.width = chartWidth;
  chart.style.height = chartHeight;

  // set the viewBox, else if the user zoomed in the power point image will also
  // be zoomed
  chart.setAttribute('viewBox', `0, 0, 1022, 1045`);

  domtoimage.toPng(clone)
    .then(function (dataUrl) {
      resolve(dataUrl);
      clone.remove();
    })
    .catch(function (error) {
        reject(error);
        clone.remove();
    });
});

// convert an image file to dataURL
export const toDataURL = url => fetch(url)
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  }));



// WEBPACK FOOTER //
// ./src/utils/createImageURL.js